/*
 * @Author: your name
 * @Date: 2021-03-10 15:02:21
 * @LastEditTime: 2021-06-23 15:51:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \hrc_shop-cart\src\components\Mqtt\sysconstant.js
 */
//线上环境
// export const MQTT_SERVICE = 'wss://hrcc9.com:8084/mqtt' //'ws://39.97.173.164:18083/mqtt' 39.97.178.92
// export const MQTT_USERNAME = 'admin'
// export const MQTT_PASSWORD = 'hrc*20200915'

//测试环境
export const MQTT_SERVICE = 'wss://hrcc9.com:8084/mqtt' //'ws://39.97.173.164:18083/mqtt' 39.97.178.92
export const MQTT_USERNAME = 'admin'
export const MQTT_PASSWORD = 'hrc*20200915'
// export const MQTT_SERVICE = 'ws://hrcc9.com:8083/mqtt' //'ws://39.97.173.164:18083/mqtt'
// export const MQTT_USERNAME = 'admin'
// export const MQTT_PASSWORD = 'hrc*20200915'


// WEBPACK FOOTER //
// ./src/components/Mqtt/sysconstant.js